// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","MapBlock":"Footer_MapBlock__-GYmU","MapLink":"Footer_MapLink__cf2lU"};